import React, { useState, useEffect } from 'react'
import FormField from '../../../../atoms/FormField/FormField'
import FormInput from '../../../../atoms/FormInput/FormInput'
import FormSelect from '../../../../atoms/FormSelect/FormSelect'
import FormTextarea, { ENTER } from '../../../../atoms/FormTextarea/FormTextarea'
import _ from 'lodash'
import Button from '../../../../atoms/Button/Button'
import { Minus, Plus } from '../../../../atoms/NewIcons'
import useTrans from '../../../../../hooks/useTrans'
//Fare handling dell'Altezza e Larghezza Massima quando si avranno tutti i dati Api
//Inserire in un filter nella select della posizone nel caso in cui isPage dovesse essere true, filtrare l'oggetto e farne il map

const Configurazione = ({ index, obj, props, setColorError, ColorError, setShowPantoni }) => {
  const t = useTrans()
  const [openDettagli, setOpenDettagli] = useState(false)

  const [Tecnica, setTecnica] = useState(
    props.values.posizioni[index] ? props.values.posizioni[index].tecnica : null
  )

  const [Posizione, setPosizione] = useState(
    props.values.posizioni[index] ? props.values.posizioni[index].posizione : null
  )

  const [Colori, setColori] = useState(
    props.values.posizioni[index] && props.values.posizioni[index].pantoni_codici
  )
  const [Altezza, setAltezza] = useState(
    props.values.posizioni[index] && props.values.posizioni[index].altezza
  )
  const [Larghezza, setLarghezza] = useState(
    props.values.posizioni[index] && props.values.posizioni[index].larghezza
  )

  const [selectedColore, setSelectedColor] = useState(
    props.values.posizioni[index] && props.values.posizioni[index].selectedColore
  )

  useEffect(() => {
    isValid()
    // ! Aggiunta preselezione Tecnica,Posizione,Colore
    try {
      const tecniche = obj?.tecniche
      !Tecnica && tecniche?.length > 0 && setTecnica(tecniche[0])
      !Posizione && tecniche[0]?.posizioni?.length > 0 && setPosizione(tecniche[0]?.posizioni[0])
      !selectedColore &&
        tecniche[0]?.posizioni[0]?.numero_colori.length > 0 &&
        setSelectedColor(tecniche[0]?.posizioni[0]?.numero_colori[0])
    } catch (error) {
      console.log(error)
    }
    props.setFieldValue(`posizioni[${index}].changedLarghezza`, false)
    props.setFieldValue(`posizioni[${index}].changedAltezza`, false)
  }, [])

  useEffect(() => {
    try {
      Tecnica.posizioni?.length === 1 && setPosizione(Tecnica?.posizioni[0])

      Tecnica.posizioni[0]?.numero_colori.length > 0 &&
        setSelectedColor(
          Tecnica.posizioni[0]?.numero_colori.find(
            (item) => item.numero_colori === Colori?.length
          ) || Tecnica.posizioni[0]?.numero_colori[0]
        )
    } catch (error) {
      console.log(error)
    }
  }, [Tecnica])

  useEffect(() => {
    if (selectedColore && props.values.posizioni[index]) {
      props.values.posizioni[index].personalizzazione_id = selectedColore
        ? selectedColore.personalizzazioni_objects[0].id
        : props.values.posizioni[index].personalizzazione_id
    }
  }, [selectedColore])

  useEffect(() => {
    if (props.values.posizioni[index]) {
      props.values.posizioni[index].personalizzazione =
        Posizione && Posizione.numero_colori.map((colore) => colore.personalizzazioni_objects)

      if (Posizione) {
        // Quando cambia la posizione ripristino i colori
        props.values.posizioni[index].personalizzazione_id = Posizione.numero_colori?.[0].personalizzazioni_objects[0].id
        setSelectedColor(Posizione.numero_colori?.[0])
        props.values.posizioni[index].selectedColore = Posizione.numero_colori?.[0]
      }
    }
    const dimensioni_db = Posizione
      ? Posizione?.numero_colori[0]?.personalizzazioni_objects[0]
      : null

    if (Posizione && Posizione.numero_colori?.[0]?.personalizzazioni_objects?.[0]?.altezza_massima === 0) {
      props.setFieldValue(`posizioni[${index}].AltezzaZero`, true)
    }

    if (Posizione) {
      setColori()
    }

    let newAltezza = null
    let newLarghezza = null
    if (dimensioni_db !== null) {
      // ? Inserito Check per altezza massima per nascondere il campo e passare comunque la validazione

      Posizione.numero_colori?.[0]?.personalizzazioni_objects?.[0]?.altezza_massima === 0
        ? (props.setFieldValue(`posizioni[${index}].altezza`, 0.116), newAltezza = 0.116)
        : dimensioni_db?.dimensione_altezza
        ? (props.setFieldValue(`posizioni[${index}].altezza`, dimensioni_db?.dimensione_altezza),
          newAltezza = dimensioni_db?.dimensione_altezza)
        : null

      dimensioni_db?.dimensione_larghezza &&
        (props.setFieldValue(`posizioni[${index}].larghezza`, dimensioni_db?.dimensione_larghezza),
        newLarghezza = dimensioni_db?.dimensione_larghezza)

      props?.validateForm()
    }

    if (Posizione) {
      setAltezza(newAltezza)
      setLarghezza(newLarghezza)
    }

  }, [Posizione])

  useEffect(() => {
    props.values.posizioni[index].pantoni_codici = Colori ? Object.values(Colori) : []
    // ! Versione Precedente in cui veniva settato manualmente il positivo
    //  Larghezza > 0 && props.setFieldValue(`posizioni[${index}].larghezza`, Larghezza)
    //  Altezza > 0 && props.setFieldValue(`posizioni[${index}].altezza`, Altezza)

    props.setFieldValue(`posizioni[${index}].altezza`, Altezza)
    props.setFieldValue(`posizioni[${index}].larghezza`, Larghezza)
  }, [Altezza, Larghezza, Colori])

  useEffect(() => {
    props.validateForm()
    isValid()
  }, [Colori, Posizione, Tecnica, selectedColore])

  const isValid = () => {
    if (Posizione && Tecnica && selectedColore) {
      if (selectedColore.personalizzazioni_objects[0].accetta_pantone === true) {
        if (Colori && Object.keys(Colori).length === selectedColore.numero_colori) {
          if (
            // ! è stata tolta la condizione colore > 0 per permettere di non dare errore con le stringhe
            Object.values(Colori).filter(
              (colore) => colore !== null && colore.toString().split('').length > 0
            ).length === selectedColore.numero_colori
          ) {
            const new_color_error = Object.assign({}, ColorError)
            new_color_error[index] = false
            setColorError(new_color_error)
          } else {
            const new_color_error = Object.assign({}, ColorError)
            new_color_error[index] = true
            setColorError(new_color_error)
          }
        } else {
          const new_color_error = Object.assign({}, ColorError)
          new_color_error[index] = true
          setColorError(new_color_error)
        }
      } else {
        const new_color_error = Object.assign({}, ColorError)
        new_color_error[index] = false
        setColorError(new_color_error)
      }
    } else {
      const new_color_error = Object.assign({}, ColorError)
      new_color_error[index] = true
      setColorError(new_color_error)
    }
  }

  return (
    <div className="configurazione__stampa__item">
      <strong>
        {t('Posizione')} {index + 1}
      </strong>
      <div className="configurazione__stampa__item-form">
        <div className="configurazione__stampa__field configurazione__stampa__field--break">
          {obj?.tecniche && (
            <FormField label={t('Tecnica')}>
              <FormSelect
                value={{
                  label: Tecnica ? Tecnica.nome : t('Scegli una Tecnica'),
                  payload: Tecnica,
                }}
                options={obj?.tecniche?.map((tecnica) => {
                  return {
                    label: tecnica.nome,
                    payload: tecnica,
                  }
                })}
                onChange={(e) => {
                  setTecnica({ ...e.payload })
                  setPosizione()
                  setSelectedColor()
                  props.values.posizioni[index].tecnica = e.payload
                }}
              />
            </FormField>
          )}
        </div>

        {Tecnica && (
          <>
            <div className="configurazione__stampa__field">
              <FormField label={t('Posizione')}>
                <FormSelect
                  value={{
                    label: Posizione ? Posizione.nome : t('Scegli una posizone'),
                    payload: Posizione,
                  }}
                  options={
                    Tecnica
                      ? Tecnica?.posizioni.map((posizione) => {
                          return {
                            label: posizione.nome,
                            payload: posizione,
                          }
                        })
                      : []
                  }
                  onChange={(e) => {
                    setPosizione(Object.assign({}, e.payload))
                    props.values.posizioni[index].posizione = e.payload
                  }}
                />
              </FormField>
            </div>
            {Posizione && (
              <div className="configurazione__stampa__field configurazione__stampa__field--wide">
                <p className="configurazione__stampa__placeholder">{t('Dimensioni (cm)')}</p>
                <div className="configurazione__stampa__wrapper__misure">
                  <div className="configurazione__stampa__wrapper__misure__input">
                    <p className="configurazione__stampa__label">
                      {t('Larghezza')}{' '}
                      {`(max ${Posizione.numero_colori[0]?.personalizzazioni_objects[0]?.base_massima})`}
                    </p>
                    <FormField
                      status={
                        _.get(props.touched, `posizioni.${index}.larghezza`)
                          ? _.get(props.errors, `posizioni.${index}.larghezza`)
                            ? 'error'
                            : 'success'
                          : Larghezza
                          ? null
                          : 'error'
                      }
                      errorMessage={_.get(props.errors, `posizioni.${index}.larghezza`)}
                    >
                      <FormInput
                        value={Larghezza ? Larghezza : ''}
                        onBlur={props.handleBlur(`posizioni[${index}].larghezza`)}
                        placeholder={
                          t('Max') +
                          ' ' +
                          Posizione.numero_colori[0].personalizzazioni_objects[0].base_massima
                        }
                        type="number"
                        onChange={(e) => {
                          let baseMax =
                            Posizione.numero_colori[0]?.personalizzazioni_objects[0]?.base_massima

                          baseMax !== 0
                            ? e.target.value > baseMax
                              ? (setLarghezza(baseMax),
                                props.setFieldValue(`posizioni[${index}].larghezza`, baseMax))
                              : (setLarghezza(e.target.value),
                                props.setFieldValue(
                                  `posizioni[${index}].larghezza`,
                                  e.target.value
                                ),
                                e.target.value != baseMax
                                  ? props.setFieldValue(
                                      `posizioni[${index}].changedLarghezza`,
                                      true
                                    )
                                  : props.setFieldValue(
                                      `posizioni[${index}].changedLarghezza`,
                                      false
                                    ))
                            : (setLarghezza(e.target.value),
                              props.setFieldValue(`posizioni[${index}].larghezza`, e.target.value),
                              e.target.value != baseMax
                                ? props.setFieldValue(`posizioni[${index}].changedLarghezza`, true)
                                : props.setFieldValue(
                                    `posizioni[${index}].changedLarghezza`,
                                    false
                                  ))
                        }}
                      />
                    </FormField>
                  </div>
                  {Posizione.numero_colori?.[0]?.personalizzazioni_objects?.[0]?.altezza_massima !==
                    0 && (
                    <div className="configurazione__stampa__wrapper__misure__input">
                      <p className="configurazione__stampa__label">
                        {t('Altezza')}{' '}
                        {`(max ${Posizione.numero_colori[0]?.personalizzazioni_objects[0]?.altezza_massima})`}
                      </p>
                      <FormField
                        status={
                          _.get(props.touched, `posizioni.${index}.altezza`)
                            ? _.get(props.errors, `posizioni.${index}.altezza`)
                              ? 'error'
                              : 'success'
                            : Altezza
                            ? null
                            : 'error'
                        }
                        errorMessage={_.get(props.errors, `posizioni.${index}.altezza`)}
                      >
                        <FormInput
                          value={Altezza ? Altezza : ''}
                          onBlur={props.handleBlur(`posizioni[${index}].altezza`)}
                          placeholder={
                            t('Max') +
                            ' ' +
                            Posizione.numero_colori[0].personalizzazioni_objects[0].altezza_massima
                          }
                          type="number"
                          onChange={(e) => {
                            let AltezzaMax =
                              Posizione.numero_colori[0]?.personalizzazioni_objects[0]
                                ?.altezza_massima

                            AltezzaMax !== 0
                              ? e.target.value > AltezzaMax
                                ? setAltezza(AltezzaMax)
                                : (setAltezza(e.target.value),
                                  e.target.value != AltezzaMax
                                    ? props.setFieldValue(
                                        `posizioni[${index}].changedAltezza`,
                                        true
                                      )
                                    : props.setFieldValue(
                                        `posizioni[${index}].changedAltezza`,
                                        false
                                      ))
                              : (setAltezza(e.target.value),
                                e.target.value != AltezzaMax
                                  ? props.setFieldValue(`posizioni[${index}].changedAltezza`, true)
                                  : props.setFieldValue(
                                      `posizioni[${index}].changedAltezza`,
                                      false
                                    ))
                          }}
                        />
                      </FormField>
                    </div>
                  )}
                </div>
              </div>
            )}
          </>
        )}

        <div className="configurazione__stampa__field configurazione__stampa__field--fullrow">
          <div className="configurazione__stampa__dettagli__posizioni">
            <Button
              variant="ghost"
              colorVariant="black"
              size="large"
              responsive={true}
              onClick={() => setOpenDettagli(!openDettagli)}
              label={t('Aggiungi dettagli posizione (facoltativo)')}
              icon={openDettagli ? <Minus /> : <Plus />}
              icon_pos="left"
            />
            {openDettagli && (
              <FormField>
                <FormTextarea
                  onChange={(e) =>
                    props.setFieldValue(`posizioni[${index}].descrizione_posizione`, e.target.value)
                  }
                  preventKeys={[ENTER]}
                  placeholder={t('Inserisci dettagli posizione')}
                />
              </FormField>
            )}
          </div>
        </div>
        {Posizione && Posizione?.numero_colori && (
          <>
            <div className="configurazione__stampa__field">
              <FormField label={t('Colori Logo')}>
                <FormSelect
                  value={{
                    label: selectedColore
                      ? selectedColore.numero_colori !== null
                        ? t('Colori {0}', [selectedColore.numero_colori])
                        : selectedColore?.nome
                      : t('Scegli Colori'),
                    payload: Posizione,
                  }}
                  options={Posizione.numero_colori.map((colore) => {
                    return {
                      label: colore.numero_colori ? colore.numero_colori : colore.nome,
                      payload: colore,
                    }
                  })}
                  onChange={(e) => {
                    setSelectedColor(e.payload)
                    props.values.posizioni[index].selectedColore = e.payload
                    setColori()
                  }}
                />
              </FormField>
            </div>
            {selectedColore &&
              selectedColore.personalizzazioni_objects[0].accetta_pantone &&
              Array(selectedColore.numero_colori)
                .fill()
                .map((_, i) => (
                  <div
                    className="configurazione__stampa__field"
                    key={`configurazione-stampa-pantone-${i}`}
                  >
                    <FormField
                      label={t('Pantone {0}', [i + 1])}
                      status={Colori ? (!Colori[i] ? 'error' : 'success') : 'error'}
                      errorMessage={
                        Colori
                          ? !Colori[i] && t('Questo campo è obbligatorio')
                          : t('Questo campo è obbligatorio')
                      }
                    >
                      <FormInput
                        style={{ maxWidth: 200 }}
                        onBlur={props.handleBlur(`posizioni[${index}].pantoni_codici`)}
                        value={Colori ? Colori[i] : ''}
                        key={i}
                        placeholder={t('Inserisci colore')}
                        onChange={(e) => {
                          let new_colori = Object.assign({}, Colori)
                          new_colori[i] = e.target.value
                          setColori(new_colori)
                          !props.values.dirty && (props.values.dirty = true)
                        }}
                        max="20"
                      />
                    </FormField>
                  </div>
                ))}
          </>
        )}
      </div>
      <Button
        variant="ghost"
        label={t('Guarda tabella pantoni')}
        onClick={() => setShowPantoni(true)}
      />
    </div>
  )
}

export default Configurazione
